import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const planos = [
  {
    nome: 'Essencial',
    tagline: 'Comece sua jornada',
    investimento: 'Gratuito',
    periodo: '',
    descricao: 'Acesso aos fundamentos do método — ideal para validar resultados antes de comprometer.',
    roi: 'Sem custo, sem risco',
    recursos: [
      '12 exercícios gratuitos de PNL',
      'Diagnóstico de padrão mental dominante',
      'Quiz de autoconhecimento',
      'Acesso à comunidade',
      'Conteúdo semanal de reprogramação',
    ],
    cta: 'Começar agora',
    link: '/exercicios-gratis',
    destaque: false,
    badge: null,
  },
  {
    nome: 'Performance',
    tagline: 'O mais escolhido por executivas',
    investimento: 'R$ 97',
    periodo: '/mês',
    descricao: 'Protocolo completo de reprogramação mental com suporte prioritário e trilha personalizada.',
    roi: 'Média de retorno: 4.2x em resultados profissionais mensuráveis em 90 dias',
    recursos: [
      'Tudo do Essencial +',
      'Protocolos avançados de PNL ilimitados',
      'Áudios guiados de alta performance',
      'Diário de manifestação e poder',
      'Reprogramação neural diária personalizada',
      'Suporte prioritário 24/7',
      'Dashboard de performance',
      'Comunidade de líderes exclusiva',
    ],
    cta: 'Iniciar meu protocolo',
    link: '/planos',
    destaque: true,
    badge: 'Mais escolhido',
  },
  {
    nome: 'Elite',
    tagline: 'Transformação definitiva',
    investimento: 'R$ 1.970',
    periodo: '/ano',
    descricao: 'Mentorias ao vivo, acesso vitalício e certificação — para quem quer o resultado mais profundo.',
    roi: 'Investimento anual equivalente a 1 sessão de coaching executivo por mês',
    recursos: [
      'Tudo do Performance +',
      '3 mentorias ao vivo/mês com Bia Holmes',
      'Acesso vitalício a todo o conteúdo',
      'Certificação em PNL & Liderança',
      'Masterclass de performance financeira',
      'Networking elite de líderes',
      'Retiro presencial anual',
      'Suporte VIP direto com Bia',
    ],
    cta: 'Entrar para a Elite',
    link: '/planos',
    destaque: false,
    badge: 'Acesso vitalício',
  },
];

const comparativo = [
  { feature: 'Exercícios de PNL', essencial: '12 gratuitos', performance: 'Ilimitados', elite: 'Ilimitados + exclusivos' },
  { feature: 'Diagnóstico personalizado', essencial: true, performance: true, elite: true },
  { feature: 'Áudios guiados MP3', essencial: false, performance: '20+ áudios', elite: '40+ áudios VIP' },
  { feature: 'Workbooks PDF', essencial: false, performance: '6 workbooks', elite: '12 workbooks' },
  { feature: 'Mentorias ao vivo', essencial: false, performance: false, elite: '3x/mês' },
  { feature: 'Suporte', essencial: 'E-mail', performance: 'Prioritário 24/7', elite: 'VIP direto' },
  { feature: 'Certificação', essencial: false, performance: false, elite: true },
  { feature: 'Acesso', essencial: 'Gratuito sempre', performance: 'Mensal cancelável', elite: 'Vitalício' },
];

export default function ComparacaoPlanos() {
  return (
    <section className="py-28 px-6 bg-[#0a0a0a] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/25 to-transparent"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(201,164,64,0.05),transparent_60%)]"></div>

      <div className="max-w-6xl mx-auto relative z-10">
        <ScrollRevealWrapper animation="fade-up">
          {/* Header */}
          <div className="max-w-2xl mb-20">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-6 bg-gold-500/50"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.25em] uppercase font-['Montserrat']">
                Investimento na sua performance
              </span>
            </div>
            <h2 className="font-display text-5xl font-bold text-white leading-[1.05] mb-5">
              O plano certo para<br />
              <span className="text-gold-400">onde você quer chegar.</span>
            </h2>
            <p className="text-white/50 text-base font-light leading-relaxed font-['Montserrat']">
              Cada plano foi desenhado para um momento diferente da jornada. Executivas que investiram no protocolo completo relatam retorno médio de <strong className="text-gold-400">4.2x</strong> em resultados profissionais mensuráveis nos primeiros 90 dias.
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Cards de planos */}
        <div className="grid lg:grid-cols-3 gap-6 mb-20">
          {planos.map((plano, i) => (
            <ScrollRevealWrapper key={plano.nome} animation="fade-up" delay={i * 0.1}>
              <div
                className={`relative rounded-2xl flex flex-col h-full transition-all duration-300 ${
                  plano.destaque
                    ? 'bg-gradient-to-br from-[#1a1400] to-[#0f0c00] border border-gold-500/30'
                    : 'bg-[#111111] border border-gold-500/10 hover:border-gold-500/25'
                }`}
              >
                {plano.badge && (
                  <div className={`absolute -top-3 left-6 px-4 py-1 rounded-full text-xs font-bold font-['Montserrat'] tracking-wide ${
                    plano.destaque
                      ? 'bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a]'
                      : 'bg-[#1a1a1a] border border-gold-500/20 text-gold-400'
                  }`}>
                    {plano.badge}
                  </div>
                )}

                <div className="p-8 flex flex-col flex-1">
                  {/* Nome e tagline */}
                  <div className="mb-6">
                    <p className={`text-xs font-semibold tracking-widest uppercase mb-1.5 font-['Montserrat'] ${
                      plano.destaque ? 'text-gold-400/70' : 'text-white/30'
                    }`}>
                      {plano.tagline}
                    </p>
                    <h3 className="font-display text-2xl font-bold text-white">
                      {plano.nome}
                    </h3>
                  </div>

                  {/* Investimento */}
                  <div className="mb-5">
                    <div className="flex items-baseline gap-1">
                      <span className="font-display text-4xl font-bold text-gold-400">
                        {plano.investimento}
                      </span>
                      {plano.periodo && (
                        <span className="text-sm text-white/35 font-['Montserrat']">
                          {plano.periodo}
                        </span>
                      )}
                    </div>

                    {/* ROI box */}
                    <div className={`mt-3 px-3 py-2 rounded-lg text-xs leading-relaxed font-['Montserrat'] ${
                      plano.destaque
                        ? 'bg-gold-500/10 border border-gold-500/20 text-gold-300/70'
                        : 'bg-white/4 border border-white/6 text-white/40'
                    }`}>
                      <i className="ri-line-chart-line mr-1.5"></i>
                      {plano.roi}
                    </div>
                  </div>

                  {/* Descrição */}
                  <p className="text-sm font-light font-['Montserrat'] leading-relaxed mb-6 text-white/45">
                    {plano.descricao}
                  </p>

                  {/* Features */}
                  <ul className="space-y-2.5 flex-1 mb-8">
                    {plano.recursos.map((r) => (
                      <li key={r} className="flex items-start gap-2.5">
                        <i className="ri-checkbox-circle-fill text-gold-400 text-base flex-shrink-0 mt-0.5"></i>
                        <span className="text-sm font-['Montserrat'] text-white/60">{r}</span>
                      </li>
                    ))}
                  </ul>

                  {/* CTA */}
                  <Link
                    to={plano.link}
                    className={`block w-full py-3.5 text-center rounded-xl font-bold text-sm tracking-wide transition-all whitespace-nowrap font-['Montserrat'] ${
                      plano.destaque
                        ? 'bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] hover:from-gold-600 hover:to-gold-800'
                        : 'bg-white/8 border border-white/15 text-white hover:bg-white/12'
                    }`}
                  >
                    {plano.cta}
                  </Link>
                </div>
              </div>
            </ScrollRevealWrapper>
          ))}
        </div>

        {/* Tabela comparativa */}
        <ScrollRevealWrapper animation="fade-up" delay={0.3}>
          <div className="bg-[#111111] border border-gold-500/10 rounded-2xl overflow-hidden mb-10">
            <div className="grid grid-cols-4 bg-[#0a0a0a] border-b border-gold-500/15 px-6 py-4">
              <div className="text-white/30 text-xs font-semibold uppercase tracking-wide font-['Montserrat']">
                Recurso
              </div>
              <div className="text-center text-white/30 text-xs font-semibold uppercase tracking-wide font-['Montserrat']">Essencial</div>
              <div className="text-center text-gold-400 text-xs font-semibold uppercase tracking-wide font-['Montserrat']">Performance</div>
              <div className="text-center text-white/30 text-xs font-semibold uppercase tracking-wide font-['Montserrat']">Elite</div>
            </div>

            {comparativo.map((row, i) => (
              <div
                key={row.feature}
                className={`grid grid-cols-4 px-6 py-4 items-center border-b border-gold-500/5 last:border-0 ${i % 2 === 0 ? 'bg-[#111111]' : 'bg-[#0f0f0f]'}`}
              >
                <span className="text-sm text-white/60 font-['Montserrat']">{row.feature}</span>
                {[row.essencial, row.performance, row.elite].map((v, vi) => (
                  <div key={vi} className="text-center">
                    {v === false ? (
                      <i className="ri-subtract-line text-white/15 text-base"></i>
                    ) : v === true ? (
                      <i className="ri-check-line text-gold-400 text-base"></i>
                    ) : (
                      <span className={`text-xs font-semibold font-['Montserrat'] ${vi === 1 ? 'text-gold-400' : 'text-white/45'}`}>{v}</span>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* Garantia */}
        <ScrollRevealWrapper animation="fade-up" delay={0.4}>
          <div className="flex flex-col sm:flex-row items-center gap-6 p-8 bg-gradient-to-r from-[#1a1400] to-[#0f0c00] rounded-2xl border border-gold-500/20">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-gold-500/12 border border-gold-500/20 flex-shrink-0">
              <i className="ri-shield-check-fill text-2xl text-gold-400"></i>
            </div>
            <div className="flex-1 text-center sm:text-left">
              <h3 className="font-display text-xl font-bold text-white mb-1">Garantia incondicional de 7 dias</h3>
              <p className="text-white/45 text-sm font-['Montserrat'] font-light leading-relaxed">
                Se por qualquer razão você não sentir resultado na primeira semana, devolvemos 100% do investimento — sem questionamentos, sem burocracia.
              </p>
            </div>
            <Link
              to="/planos"
              className="flex-shrink-0 px-6 py-3 bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] rounded-full font-bold text-sm whitespace-nowrap hover:from-gold-600 hover:to-gold-800 transition-all font-['Montserrat']"
            >
              Ver todos os planos
            </Link>
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
